import React from "react";
import { primaryTextColorShade } from "../../utils/constants";

export default function TPNoRatingIndicator({ color = primaryTextColorShade }) {
  return (
    <svg
      id="TP-no-rating-indicator"
      xmlns="http://www.w3.org/2000/svg"
      width="44.565"
      height="44.564"
      viewBox="0 0 44.565 44.564"
    >
      <path
        id="Vereinigungsmenge_20"
        data-name="Vereinigungsmenge 20"
        d="M12447,22077.848a22.283,22.283,0,1,1,22.286,22.285A22.282,22.282,0,0,1,12447,22077.848Zm14-19.611a21.378,21.378,0,1,0,8.286-1.67A21.34,21.34,0,0,0,12461,22058.236Zm5.579,27.354a2.322,2.322,0,0,1,2.4-2.213,2.222,2.222,0,1,1,0,4.432A2.329,2.329,0,0,1,12466.579,22085.59Zm.355-3.814c-.239-3.029.56-4.377,2.269-5.447,1.259-.781,2.029-1.486,2.029-2.557a1.835,1.835,0,0,0-1.952-1.83,2.052,2.052,0,0,0-2.107,2.063h-4.249c.056-3.877,2.918-5.607,6.39-5.607,3.8,0,6.567,1.814,6.567,5.164a5,5,0,0,1-2.707,4.443c-1.725,1.059-2.308,1.641-2.308,3.771Z"
        transform="translate(-12447 -22055.568)"
        fill={color}
      />
    </svg>
  );
}
